import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=4b3e4290&scoped=true&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=4b3e4290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e4290",
  null
  
)

export default component.exports